export const AppStatus = {
    Started: 0,
    Downloading: 1,
    DownloadFailed: 2,
    Installing: 3,
    InstallFailed: 4,
    Restarting: 5,
    UpdateAvailable: 6,
}